import { AxiosError } from 'axios';
import { SystemSettingsRequest, UpdateConfigModelObject } from 'web-library/models/Request';
import { POST_SYSTEM_SETTINGS_REQUEST_URL } from 'web-library/constants/apiUrls';
import { useCustomMutation } from '../utils/useCustomMutation';
import axiosClient from '../axiosClient';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: UpdateConfigModelObject[]) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostSystemSettingsRequest = ({ onSuccess, onError }: Input = {}) => {
  const postSystemSettingsRequest = async (reqBody: SystemSettingsRequest) => {
    const res = await axiosClient.post<UpdateConfigModelObject[]>(
      POST_SYSTEM_SETTINGS_REQUEST_URL,
      reqBody
    );
    return res.data;
  };

  return useCustomMutation(postSystemSettingsRequest, {
    onSuccess,
    onError,
  });
};
